var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.95723 1C1.87628 1 1 1.87628 1 2.95723V10.1819C1 11.2628 1.87628 12.1391 2.95723 12.1391H4.15629V13.7981C4.15629 14.466 4.69773 15.0075 5.36564 15.0075H13.7906C14.4585 15.0075 15 14.466 15 13.7981V5.36807C15 4.70017 14.4585 4.15872 13.7906 4.15872H12.1346V2.95723C12.1346 1.87628 11.2583 1 10.1774 1H2.95723ZM10.6388 4.15872V2.95723C10.6388 2.70237 10.4322 2.49577 10.1774 2.49577H2.95723C2.70237 2.49577 2.49577 2.70237 2.49577 2.95723V10.1819C2.49577 10.4367 2.70237 10.6433 2.95723 10.6433H4.15629V5.36807C4.15629 4.70017 4.69773 4.15872 5.36564 4.15872H10.6388ZM5.65206 13.5117V5.65449H13.5042V13.5117H5.65206Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic_copy.61cfa18c1486912b198521ccbf355da7.svg";
export { ForwardRef as ReactComponent };